import classNames from 'classnames';
import React from 'react';
import { Flipper } from 'react-flip-toolkit';
import styles from './index.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
  cardSize?: 'small' | 'medium' | 'large' | 'fullSize';
  flipKey?: string | null;
}

export const CardGrid = (props: Props) => {
  const { children, className, cardSize = 'medium', flipKey = null, ...rest } = props;
  const containerClass = classNames(styles.grid, className, styles[`card-size-${cardSize}`], {
    [styles.relative]: flipKey !== null,
  });

  return flipKey !== null ? (
    <Flipper flipKey={flipKey} className={containerClass} {...rest}>
      {children}
    </Flipper>
  ) : (
    <div className={containerClass} data-testid="card-grid" {...rest}>
      {children}
    </div>
  );
};
